import React from 'react';
import { Controller, Control } from 'react-hook-form';
import _get from 'lodash/get';

import Number from '../baseui/input/number';

interface INumberInput {
	name: any;
	control: Control<Record<string, any>, object> | undefined;
	defaultValue: any;
	onChangeCallback?: (props: any) => void;
}

const NumberInput: React.FC<INumberInput> = (props) => {
	const { name, control, defaultValue, onChangeCallback } = props;

	return (
		<Controller
			render={({ field: { onChange, value } }) => {
				return <Number onChangeCallback={onChangeCallback} {...props} value={value} onChange={onChange} />;
			}}
			control={control}
			name={name}
			defaultValue={defaultValue && _get(defaultValue, ['field', ...defaultValue.path])}
		/>
	);
};

export default NumberInput;
